import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useNavigate, useMatch } from 'react-router-dom';

const TAB_BAR_STYLE = { marginBottom: 0 };

interface ConnectSubNavProps {
  basePath: string;
  items: { key: string; label: string; disabled?: boolean }[];
}

const ConnectSubNav: React.FC<ConnectSubNavProps> = ({ basePath, items }) => {
  const navigate = useNavigate();
  const match = useMatch(`${basePath}/:subTab`);
  const activeKey = match?.params.subTab;

  const handleTabClick = (key: string) => {
    navigate({ pathname: `${basePath}/${key}`, search: '' });
  };

  const tabItems: TabsProps['items'] = items.map(({ key, label, disabled }) => ({
    key,
    label,
    disabled,
  }));

  return (
    <div className="bg-surface border-b border-strong px-6">
      <Tabs
        activeKey={activeKey}
        items={tabItems}
        onTabClick={handleTabClick}
        tabBarStyle={TAB_BAR_STYLE}
        className="[&_.ant-tabs-content-holder]:hidden"
      />
    </div>
  );
};

export default ConnectSubNav;
